import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../utils/axiosInstance";
import axiosInstance from './../../../utils/axiosInstance';

export const historyApi = createAsyncThunk('history', async (payload) => {
    const response = await axiosInstance.post('/customTrade/getOrderHistory2',payload);
    return response.data;
});

const historySlice = createSlice({
    name: "history",
    initialState: {
        data: [],
        errors: [],
        loading: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(historyApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(historyApi.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(historyApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.loading = false;
            });
    }
});

export default historySlice.reducer;
